<form [formGroup]="form" autocomplete="off" class="minclt-form-print"
	[ngClass]="{ 'ng-invalid ng-dirty': form.invalid && (form.dirty || form.touched) }">
	<div class="p-formgrid grid">
		<ng-content select="[header]"></ng-content>
		<ng-container *ngFor="let question of questions; let i = index">
			<div *ngIf="question.show" [ngClass]="question.col ? question.col : 'col-12 py-2'" class="my-auto">
				<div *ngIf="(question.typeInput === 'input' || questions.typeInput === 'password') && question.show"
					class="field p-fluid">
					<label *ngIf="!formFilter  && question.label"
						class="font-semibold overflow-hidden white-space-nowrap text-overflow-ellipsis"
						[htmlFor]="question.key" [ngStyle]="{ 'opacity': question.disabled  ? '.5' : '1'}">
						{{ question.label }}
						<ng-container
							*ngIf="(question.type === 'text' || question.type === 'textarea' ) && question.maxlength && (question.maxlength  - 1) >= countCharacters(question)">
							- {{ countCharacters(question) }} caracteres restantes
						</ng-container>
					</label>
					<input *ngIf="question.type === 'text'" [id]="question.key" pInputText matInput
						[placeholder]="question.placeholder || ''" [formControlName]="question.key"
						[styleClass]="'custom-dropdown'" [escape]="false"
						[tooltipStyleClass]="question.tooltip ? 'custom-tooltip' : null"
						[pTooltip]="question.tooltip || null" tooltipPosition="bottom"
						[tabindex]="question.tabindex || 0" [maxlength]="question.maxlength"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }"
						(focus)="handleTooltipFocus(question.type, question.key, question.tooltip || null, 'show')"
						(blur)="inputBlur($event.target.value, question.key);
							handleTooltipFocus(question.type, question.key, question.tooltip || null, 'hide')" #tooltipInputTexts>
					<p-inputNumber *ngIf="question.type === 'number' && question.blockPaste !== true"
						[id]="question.key" [inputId]="question.key" [placeholder]="question.placeholder || ''"
						[formControlName]="question.key" [mode]="'decimal'" [locale]="'es-CO'"
						[prefix]="question.showCurrency ? '$ ' : ''"
						[minFractionDigits]="question.mode === 'decimal' ? 2 : 0"
						[maxFractionDigits]="question.mode === 'decimal' ? 2 : 0" [format]="true"
						[useGrouping]="question.decimalSeparator" [styleClass]="'custom-dropdown'" [escape]="false"
						[tooltipStyleClass]="question.tooltip ? 'custom-tooltip' : null"
						[pTooltip]="question.tooltip || null" tooltipPosition="bottom"
						[tabindex]="question.tabindex || 0"
						(onFocus)="handleTooltipFocus(question.type, question.key, question.tooltip || null, 'show')"
						(onBlur)="handleInputNumber($event.target.value, question); handleTooltipFocus(question.type, question.key, question.tooltip || null, 'hide')"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }" #tooltipInputNumbers />
					<p-inputNumber *ngIf="question.type === 'number' && question.blockPaste === true"
						[id]="question.key" [inputId]="question.key" [placeholder]="question.placeholder || ''"
						[formControlName]="question.key" [mode]="'decimal'" [locale]="'es-CO'"
						[prefix]="question.showCurrency ? 'COP ' : ''"
						[minFractionDigits]="question.mode === 'decimal' ? 2 : 0"
						[maxFractionDigits]="question.mode === 'decimal' ? 2 : 0" [format]="true"
						[useGrouping]="question.decimalSeparator" [styleClass]="'custom-dropdown'" [escape]="false"
						[tooltipStyleClass]="question.tooltip ? 'custom-tooltip' : null"
						[pTooltip]="question.tooltip || null" tooltipPosition="bottom"
						[tabindex]="question.tabindex || 0" (onBlur)="handleInputNumber($event.target.value, question)"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }" #inputNumbersBlockPaste />
					<p-inputNumber *ngIf="question.type === 'porcentaje'" [id]="question.key" [inputId]="question.key"
						[placeholder]="question.placeholder || ''" [formControlName]="question.key" [mode]="'decimal'"
						[min]="0" [max]="100" [minFractionDigits]="0" [maxFractionDigits]="0" [format]="true"
						[showButtons]="true" [suffix]="'%'" [useGrouping]="false" [styleClass]="'custom-dropdown'"
						[escape]="false" [tooltipStyleClass]="question.tooltip ? 'custom-tooltip' : null"
						[pTooltip]="question.tooltip || null" tooltipPosition="bottom"
						[tabindex]="question.tabindex || 0"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }"
						(onBlur)="handleInputNumber($event.target.value, question)" />
					<p-password *ngIf="question.type === 'password'" [toggleMask]="true"
						[formControlName]="question.key" [feedback]="false" [placeholder]="question.placeholder || ''"
						[styleClass]="'custom-dropdown'" [escape]="false"
						[tooltipStyleClass]="question.tooltip ? 'custom-tooltip' : null"
						[pTooltip]="question.tooltip || null" tooltipPosition="bottom"
						[tabindex]="question.tabindex || 0"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }" />
					<textarea *ngIf="question.type === 'textarea'" rows="3" pInputTextarea [id]="question.key"
						[placeholder]="question.placeholder || ''" [formControlName]="question.key" [autoResize]="true"
						[style.min-height.!important]="'78px'" [styleClass]="'custom-dropdown'" [escape]="false"
						[tooltipStyleClass]="question.tooltip ? 'custom-tooltip' : null"
						[pTooltip]="question.tooltip || null" tooltipPosition="bottom"
						[tabindex]="question.tabindex || 0" [maxlength]="question.maxlength"
						(focus)="handleTooltipFocus(question.type, question.key, question.tooltip || null, 'show')"
						(blur)="inputBlur($event.target.value, question.key);
							handleTooltipFocus(question.type, question.key, question.tooltip || null, 'hide')"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }" #tooltipTextAreas>
					</textarea>
					<p-editor *ngIf="question.type === 'html' && !question.readonly" [formControlName]="question.key"
						[style]="{ height: '320px' }" />
					<div *ngIf="question.type === 'html' && question.readonly" [innerHTML]="question.value"></div>
					<small *ngIf="isInvalid(question.key)" style="color: #b00020;">
						<span *ngIf="form.controls[question.key].errors.required && question.blockPaste !== true">
							El campo es requerido
						</span>
						<span *ngIf="form.controls[question.key].errors.required && question.blockPaste === true">
							La información ingresada no coincide con lo esperado, por lo tanto, ha sido eliminada.
						</span>
						<span *ngIf="form.controls[question.key].errors.minlength">
							Mínimo de caracteres invalido
						</span>
						<span *ngIf="form.controls[question.key].errors.maxlength">
							Maximo de caracteres invalido
						</span>
						<span *ngIf="form.controls[question.key].errors.email">
							Email invalido
						</span>
						<span *ngIf="form.get(question.key)?.hasError('fieldsMismatch')">
							Los valores no coinciden
						</span>
					</small>
					<small *ngIf="isMaxLengthReached(question) && question.type === 'number'" class="morado">
						<span>
							<strong>Máximo {{ question.rules?.maxLength }} dígitos permitidos.</strong>
						</span>
					</small>

				</div>
				<div *ngIf="question.typeInput === 'select'" class="field p-fluid">
					<label *ngIf="!formFilter && question.label"
						class="font-semibold overflow-hidden white-space-nowrap text-overflow-ellipsis"
						[htmlFor]="question.key" [ngStyle]="{ 'opacity': question.disabled  ? '.5' : '1'}">
						{{ question.label }}
					</label>
					<p-dropdown *ngIf="question.type === 'simple_select'" [id]="question.key"
						[formControlName]="question.key" [options]="question.options" optionLabel="text"
						[filter]="question.filter" [placeholder]="question.placeholder || ''" optionValue="value"
						[styleClass]="'custom-dropdown'" [escape]="false"
						[tooltipStyleClass]="question.tooltip ? 'custom-tooltip' : null"
						[pTooltip]="question.tooltip || null" tooltipPosition="bottom"
						(onFocus)="handleTooltipFocus(question.type, question.key, question.tooltip || null, 'show')"
						(onBlur)="handleTooltipFocus(question.type, question.key, question.tooltip || null, 'hide')"
						(onShow)="handleTooltipFocusOnSelect(question.type, question.key)"
						[tabindex]="question.tabindex || 0"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }" (onChange)="onChangeSingleSelect.emit(
							{ value: $event.value,  key: question.key, keyValue: getKeyValueById($event.value, question.options)}
							)" appendTo="body" #tooltipSelect>
						<ng-template pTemplate="item" let-item>
							<div [tooltipStyleClass]="item.tooltip ? 'custom-tooltip' : null"
								[pTooltip]="item.tooltip || null" tooltipPosition="top" #tooltipSelectItems>
								{{ item.text }}
							</div>
						</ng-template>
					</p-dropdown>
					<p-multiSelect *ngIf="question.type === 'multiselect'" [id]="question.key"
						[options]="question.options" [formControlName]="question.key" optionLabel="text"
						optionValue="value" [placeholder]="question.placeholder || ''" [styleClass]="'custom-dropdown'"
						[escape]="false" [tooltipStyleClass]="question.tooltip ? 'custom-tooltip' : null"
						[pTooltip]="question.tooltip || null" tooltipPosition="bottom"
						(onFocus)="handleTooltipFocus(question.type, question.key, question.tooltip || null, 'show')"
						(onBlur)="handleTooltipFocus(question.type, question.key, question.tooltip || null, 'hide')"
						(onPanelShow)="handleTooltipFocusOnSelect(question.type, question.key)"
						(onPanelHide)="handleOverlayClose(question,  i)" [tabindex]="question.tabindex || 0"
						(onChange)="onMultiSelectChange(question)"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }" appendTo="body"
						#tooltipMultiselect>
						<ng-template pTemplate="item" let-item>
							<div [ngClass]="{ 'p-disabled': isDisabledOption(item, question) }"
								[tooltipStyleClass]="item.tooltip ? 'custom-tooltip' : null"
								[pTooltip]="item.tooltip || null" tooltipPosition="top" #tooltipMultiSelectItems>
								{{ item.text }}
							</div>
						</ng-template>
					</p-multiSelect>
					<small *ngIf="isInvalid(question.key)" style="color: #b00020;">
						<span *ngIf="form.controls[question.key].errors.required">
							El campo es requerido
						</span>
					</small>
				</div>
				<div *ngIf="question.typeInput === 'date'" class="field p-fluid">
					<label *ngIf="!formFilter && question.label"
						class="font-semibold overflow-hidden white-space-nowrap text-overflow-ellipsis"
						[htmlFor]="question.key">{{ question.label }}</label>
					<p-calendar [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
						[formControlName]="question.key" [id]="question.key" [selectionMode]="question.type"
						[readonlyInput]="true" [placeholder]="question.placeholder || ''" [minDate]="question.minDate"
						[maxDate]="question.maxDate" dateFormat="dd/mm/yy" [tabindex]="question.tabindex || 0"
						[ngClass]="{ 'ng-invalid ng-dirty': isInvalid(question.key) }" appendTo="body"
						(onSelect)="onChangeValueDateField.emit({ value: $event, key: question.key})" />
					<small *ngIf="isInvalid(question.key)" style="color: #b00020;">
						<span *ngIf="form.controls[question.key].errors.required">
							El campo es requerido
						</span>
					</small>
				</div>
				<div *ngIf="question.typeInput === 'file'" class="field p-fluid">
					<label class="font-semibold overflow-hidden white-space-nowrap text-overflow-ellipsis"
						[htmlFor]="question.key" [ngStyle]="{ 'opacity': question.disabled  ? '.5' : '1'}">{{
						question.label }}</label>
					<p-fileUpload styleClass="w-full" (onSelect)="onSelectFileToByField($event, question.key)"
						mode="basic" [chooseLabel]="question.label" uploadLabel="Subir archivo"
						chooseIcon="pi pi-upload" name="file" [accept]="question.accept" />
					<small *ngIf="isInvalid(question.key)" style="color: #b00020;">
						<span *ngIf="form.controls[question.key].errors.required">
							El campo es requerido
						</span>
					</small>
				</div>
				<div *ngIf="question.typeInput === 'check'"
					class="field p-fluid h-full flex flex-column justify-content-between align-items-center"
					style="max-height: 54px;">
					<label class="font-semibold text-center" [htmlFor]="question.key" style="font-size: 9px;"
						[ngStyle]="{ 'opacity': question.disabled  ? '.5' : '1'}">
						{{ question.label }}</label>
					<p-checkbox [formControlName]="question.key" binary="true"></p-checkbox>
				</div>
				<div *ngIf="question.typeInput === 'toggle'"
					class="field p-fluid h-full flex gap-2 align-items-center justify-content-between"
					style="max-height: 150px;">
					<label class="font-semibold text-left" [htmlFor]="question.key" style="margin-bottom: 0;"
						[ngStyle]="{ 'opacity': question.disabled  ? '.5' : '1'}">
						{{ question.label }}</label>
					<div class="input-switch-wrapper" [id]="question.key"
						[tooltipStyleClass]="question.tooltip ? 'custom-tooltip' : null" [escape]="false"
						[pTooltip]="question.tooltip || null" tooltipPosition="bottom" tooltipEvent="manual"
						(focus)="handleTooltipFocus(question.typeInput, question.key, question.tooltip || null, 'show')"
						(blur)="handleTooltipFocus(question.typeInput, question.key, question.tooltip || null, 'hide')"
						[tabindex]="question.tabindex || 0" (keydown.enter)="toggleSwitch(question.key)"
						#tooltipinputSwitch>
						<p-inputSwitch [formControlName]="question.key" [tabindex]="-1"
							[tooltipStyleClass]="question.tooltip ? 'custom-tooltip' : null" [escape]="false"
							[pTooltip]="question.tooltip || null" tooltipPosition="bottom"
							(onChange)="handleChangeInputSwitch($event, question)" />
						<div class="flex align-items-center justify-content-evenly absolute label-inputSwitch">
							<span [ngStyle]="{ 'opacity': form.get(question.key)?.value  ? '1' : '0'}">Sí</span>
							<span [ngStyle]="{ 'opacity': form.get(question.key)?.value  ? '0' : '1'}">No</span>
						</div>
					</div>
				</div>
				<div *ngIf="question.typeInput === 'invisible_field'"
					class="field p-fluid h-full flex gap-3 align-items-center justify-content-between"
					style="max-height: 150px;">
					<label class="font-semibold text-left" [htmlFor]="question.key" style="margin-bottom: 0;"></label>
				</div>
			</div>
		</ng-container>
		<div *ngIf="formFilter && showButtonsSubmit" class="col-12 md:col-2 p-fluid">
			<p-button [label]="textButtonSubmit" (click)="submitForm()"></p-button>
		</div>

		<ng-content select="[footer]"></ng-content>

		<div *ngIf="showClearFilters" class="col-12 md:col-1 p-fluid flex">
			<app-boton-svg [nombre]="'restaurar'" [color]="'amarillo'" [size]="'33'" [borderRadius]="'8'"
				(click)="onClickClearFiltersForm()" [pTooltip]="'Limpiar busqueda'" tooltipPosition="bottom" />
		</div>
	</div>
	<div *ngIf="!formFilter && showButtonsSubmit" class="flex justify-content-end gap-2 mt-5">
		<p-button label="Cancelar" severity="secondary" (click)="cancelQuestions.emit()"></p-button>
		<p-button [label]="textButtonSubmit" (click)="submitForm()"></p-button>
	</div>
</form>